export default class AppController {
  /* @ngInject */
  constructor(SidebarService, AuthService) {
    this.sidebarService = SidebarService;
    this.authService = AuthService;
  }

  sidebarIsVisible() {
    return this.sidebarService.isVisible();
  }

  isLogged() {
    return this.authService.token();
  }

  goHome() {
    this.sidebarService.goHome();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.controller.js